import styled from 'styled-components'
import { P, H3 } from 'konsys-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-image: ${props => `url(${props.bg})`};
  background-size: cover;
  border: ${props => props.border};
  padding: ${props => props.padding};
`

export const SpaceBetweenWrapper = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: ${props => (props.width ? props.width : 'auto')};
  height: ${props => (props.height ? props.height : 'auto')};
  margin: ${props => props.margin};
`

export const Title = styled(H3)`
  font-weight: 600;
  color: #d95948;
`

export const Text = styled(P)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export default Container
